import { Input } from './Input'

export const Select = {
  variants: {
    outline: {
      field: {
        boxShadow: 'unset',
        backgroundColor: 'white',
        borderColor: 'product.border.solid',
        borderWidth: '1px',
        _hover: {
          borderColor: 'product.secondary',
        },
        _active: {
          borderColor: 'product.secondary',
        },
        _focus: {
          borderColor: 'product.secondary',
        },
        _focusVisible: {
          boxShadow: '0 0 4px 0 var(--chakra-colors-cyan-600)',
          borderColor: 'cyan.100',
        },
        _disabled: {
          bg: 'gray.50',
          _hover: {
            bg: 'gray.50',
          },
        },
        _invalid: {
          backgroundColor: 'white',
          borderColor: 'product.state.solid.error',
          boxShadow: 'unset',
          _hover: {
            borderColor: 'product.state.solid.error',
          },
          _focus: {
            boxShadow: 'unset',
            borderColor: 'product.state.solid.error',
            backgroundColor: 'white',
          },
        },
      },
      icon: {
        insetEnd: 1,
        width: 8,
      },
    },
    filled: {
      field: {
        ...Input.variants.filled.field,
      },
    },
  },
  sizes: Input.sizes,
}
